import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Navigation from '../components/Navigation';
import { listAccounts } from '../actions/accountActions';

const AccountPage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userLogin = useSelector((state: appState) => state.userLogin);
  const { userData } = userLogin;

  useEffect(() => {
    if (!userData) {
      navigate('/');
      return;
    }

    dispatch(listAccounts());
  }, [navigate, dispatch, userData]);

  const lastFour = (str: string) => {
    return str.slice(-4);
  };

  const accountsList = useSelector((state: appState) => state.accountsList);
  const { loading, error, accounts } = accountsList;

  return (
    <div className='account-page'>
      <Navigation />
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className='error'>{error}</p>
      ) : (
        <div className='account-body'>
          <div className='welcome'>
            {userData && <h1>Welcome, {userData.name}</h1>}
            <h3>Account Summary</h3>
          </div>
          {accounts.map((account) => (
            <div className='account-info' key={account.id}>
              <p>
                {account.type} {lastFour(account.number)}
              </p>
              <p>${account.balance.toFixed(2)}</p>
            </div>
          ))}
          <div className='account-boxes'>
            <Link to={'/deposit'} className='account-box deposit-box'>
              <h3>Deposit</h3>
              <i className='fas fa-dollar-sign'></i>
              <p>Make a deposit.</p>
            </Link>
            <Link to={'/withdraw'} className='account-box withdraw-box'>
              <h3>Withdraw</h3>
              <i className='fas fa-wallet'></i>
              <p>Withdraw cash.</p>
            </Link>
            <Link to={'/transfer'} className='account-box transfer-box'>
              <h3>Transfer</h3>
              <i className='fas fa-exchange-alt'></i>
              <p>Transfer money.</p>
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountPage;
